import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { VisitorsSummary } from '../../../../apis/users/users.api.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getVisitorsSummaryKey = 'get-visitors-summary';

export const useVisitorsSummaryHook = (
  options?: Omit<UseQueryOptions<VisitorsSummary, TQueryError>, 'queryKey' | 'queryFn'>
): UseQueryResult<VisitorsSummary, TQueryError> => {
  const { getVisitorUsersSummary } = useUsersService();

  return useQuery<VisitorsSummary, TQueryError>({
    queryKey: [getVisitorsSummaryKey],
    queryFn: () => getVisitorUsersSummary(),
    enabled: true,
    ...options,
  });
};
